var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueRecaptcha',{attrs:{"sitekey":_vm.siteKey,"size":"normal","type":"checkbox"},on:{"verify":_vm.onVerify}})
}
var staticRenderFns = []

export { render, staticRenderFns }